import React from "react";
import BestOf from "./pages/BestOf";
import MenuBestOf from "./pages/MenuBestOf";
import { useMenuBestOf } from "./context/MenuBestOf";

function App() {
  const { state: stateMenu} = useMenuBestOf();

  return (
    <>
      {stateMenu.pickedBestOf || stateMenu.isNewBestOf ? <BestOf /> : <MenuBestOf/>}
    </>
  );
}

export default App;
